import React from 'react'
import { connect } from 'react-redux'
import { t } from 'i18next'

import NextWeekIcon from '../svg/next-week'
import '../components/modal.css'
import { SHOW_PAGE } from '../actions'

const NewQuestions = ({ updatePage, hideModal }) => {
  const confirm = () => {
    updatePage('ranking')
  }

  return (
    <div className="view-inner">
      <div className="modal-container">
        <div className="modal-inner text-center">
          <NextWeekIcon />
          <div className="modal-content">
            <p>{t('nextweek.new')}</p>
          </div>
          <div className="modal-btn-group">
            <button className="btn btn-base full btn-navy-blue" onClick={confirm}>
              {t('nextweek.ok')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatch = dispatch => {
  return {
    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    }
  }
}

const Component = connect(null, mapDispatch)(NewQuestions)
Component.displayName = 'nextWeek'

export default Component



// WEBPACK FOOTER //
// ./src/pages/NextWeek.js